import { GetServerSideProps } from "next";
/* eslint-disable @typescript-eslint/no-explicit-any */
import Router from "next/router";

import { styles } from "@/components/BreadcrumbsHeader/styles";
import { Container } from "@/components/Container";
import { CoverPartnersInformation } from "@/components/PartnersInformationPage/CoverPartnersInformation";
import { Doubt } from "@/components/PartnersInformationPage/Doubt";
import { Regulation } from "@/components/Regulation";
import { useDisclose } from "@/hooks/utilHooks";
import { PartnersInformationPageService } from "@/services/contentful/partnersInformationPage";
import { PlatformConfigurationService } from "@/services/contentful/platformConfiguration";
import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";
import { Button, Stack } from "@mui/material";
import { CaretLeft, FileText } from "@phosphor-icons/react";

export const styles_btn = {
  button_voltar: css`
    color: #000000;
    font-size: 16px;
    width: fit-content;
    font-weight: 400;
    text-transform: none;

    &:hover {
      font-weight: 500;
    }
  `
};

interface ParceirosProps {
  regulation?: any;
  header?: any;
  questionsSubheading?: any;
  titleQuestions?: any;
  questionsAndAnswersList?: any;
  partnersInformationPage?: any;
  informative?: any;
  viewQuestionList?: any;
}

const Parceiros: React.FC<ParceirosProps> = ({
  partnersInformationPage,
  questionsAndAnswersList,
  titleQuestions,
  questionsSubheading,
  header,
  regulation,
  viewQuestionList
}) => {
  const { onOpen, onClose, isOpen } = useDisclose();

  const effectiveQuestionsAndAnswersList = questionsAndAnswersList || partnersInformationPage?.questionsAndAnswersList;
  const effectiveTitleQuestions = titleQuestions || partnersInformationPage?.titleQuestions;
  const effectiveQuestionsSubheading = questionsSubheading || partnersInformationPage?.questionsSubheading;
  const effectiveHeader = header || partnersInformationPage?.header;
  const effectiveRegulation = regulation || partnersInformationPage?.regulation;
  const effectiveViewQuestionList = viewQuestionList || partnersInformationPage?.viewQuestionList;

  return (
    <>
      {!partnersInformationPage && (
        <Stack
          sx={{
            height: "auto",
            bgcolor: theme.palette.grey[200],
            display: "flex",
            flexDirection: { sm: "row", xs: "column" },
            alignItems: { sm: "center", xs: "start" },
            justifyContent: "space-between",
            mt: 1,
            py: 2,
            pr: { lg: 10, md: 4, sm: 2, xs: 2 }
          }}
        >
          <Container mt={{ xs: 2, md: 3 }} mb={2} py={0} pl={{ xs: "9px", sm: "18px", md: "70px", lg: "70px" }}>
            <Button startIcon={<CaretLeft size={24} />} variant="text" onClick={() => Router.push("/ganhe-km")} css={styles_btn.button_voltar}>
              Voltar
            </Button>
          </Container>
          {effectiveRegulation?.document ? (
            <Button
              size="medium"
              variant="contained"
              css={styles.regulamento__button}
              onClick={onOpen}
              startIcon={<FileText size={24} color="#FFFFFF" fontWeight={600} />}
              fullWidth={false}
            >
              Regulamento da parceria
            </Button>
          ) : null}
        </Stack>
      )}

      <Regulation
        isOpen={isOpen}
        onClose={onClose}
        pdf={effectiveRegulation?.document}
        allowDownload={effectiveRegulation?.document ? effectiveRegulation?.allowDownload : false}
      />
      <CoverPartnersInformation
        backgroundColor={effectiveHeader?.backgroundColor}
        description={effectiveHeader?.description}
        image={effectiveHeader?.secondaryImage}
        textColor={effectiveHeader?.textColor}
        title={effectiveHeader?.title}
        url={effectiveHeader?.url}
        secondaryImage={effectiveHeader?.image}
        subtitle={effectiveHeader?.subtitle}
        thirdImage={effectiveHeader?.thirdImage}
        informative={effectiveHeader?.informative}
        descriptionWithRichText={effectiveHeader?.descriptionWithRichText}
        buttonTitle={effectiveHeader?.buttonTitle}
        buttonColor={effectiveHeader?.buttonColor}
      />
      {effectiveViewQuestionList ? (
        <Doubt doubtList={effectiveQuestionsAndAnswersList} title={effectiveTitleQuestions} description={effectiveQuestionsSubheading} />
      ) : null}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { partnerId } = context.params as any;

  if (!partnerId) {
    return {
      notFound: true
    };
  }

  const [props, { menuItems, simulatorAccumulationInformativeText, locationCompany }] = await Promise.all([
    PartnersInformationPageService.partnersInformationPage({ partnerId: partnerId }),
    PlatformConfigurationService.getData()
  ]);

  Object.assign(props, { pageTitle: "Parceiros", menuItems, simulatorAccumulationInformativeText, locationCompany });

  return { props };
};

export default Parceiros;
